export default "__VITE_ASSET__UDcs6jsO__"